export default __webpack_public_path__ + "static/media/article01.9203583b.md";